import React from 'react';
import { Modal } from 'antd';
import QRCode from "qrcode";

export default () => {

    const createWXChat = async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const data = Object.fromEntries(formData.entries());
        console.log('data', data);
        // return false;
        const response = await fetch('/api/tools/create-wxchat', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const result = await response.json();
        console.log(result);
        
        Modal.info({
            content: result.data.chatid || result.data.errmsg
        });
        return false;
    }

    const createWXCalendar = async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const data = Object.fromEntries(formData.entries());
        console.log('data', data);
        // return false;
        const response = await fetch('/api/tools/create-wxcalendar', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const result = await response.json();

        Modal.info({
            content: result.data.cal_id || result.data.errmsg,
        });
        return false;
    }

    const getPayInfoByWid = async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const data = Object.fromEntries(formData.entries());
        console.log('data', data);
        // return false;
        const response = await fetch('/api/wm/get-wm-user-channel-list', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const result = await response.json();

        console.log('result', result);
        return false;
    }
    
    return <div>
        <h1>工具</h1>
        <h4>企业微信工具</h4>
        <form id='createWXChatForm' onSubmit={(e) => createWXChat(e)}>
            <div>创建微信群</div>
            <div style={{ display: 'flex' }}>
                <div>群名称: <input name='name' placeholder='' /></div>
                <div>Chatid: <input name='chatid' placeholder='ALSorderHZ' /></div>
                <button type='submit'>提交</button>
            </div>
        </form>

        <form onSubmit={(e) => createWXCalendar(e)}>
            <div>创建微信日历</div>
            <div style={{ display: 'flex' }}>
                <div>城市: <input name='city' placeholder='ALSorderHZ' /></div>
                <button type='submit'>创建</button>
            </div>
        </form>
        <h4>微盟API</h4>

        <form onSubmit={(e) => getPayInfoByWid(e)}>
            <div>根据wid查询openid</div>
            <div style={{ display: 'flex' }}>
                <div>wid: <input name='wid' placeholder='wid' /></div>
                <button type='submit'>查询</button>
            </div>
        </form>
    </div>;
}

// 生成微信支付二维码
export const createWXPayQRCode = async ({orderNo, accId, amount, shopId}) => {
    amount = amount * 100; // 单位为分
    amount = Math.floor(amount);

    let response = await fetch('/api/pay/wx-native-pay', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            orderNo,
            amount,
            accId,
            shopId
            // notify_url: window.location.origin
        })
    });

    let result = await response.json();

    const codeUrl = result?.data?.code_url;
    let imageUrl = '';

    if(codeUrl) imageUrl = await QRCode.toDataURL(codeUrl);

    return { codeUrl , imageUrl }
}
